@use "../../mixins" as *;

.list-content {
  position: relative;
  display: flex;
  width: 100%;
  // no 'margin' needed since it works in dev/staging/prod

  @include tablet {
    top: 2rem;
  }
}